<template>
  <div>
    <div
      class="group-bar"
      :class="{ selected: isTargetGroupContentOpened(group.documentId) }"
      :style="
        '--color:' +
        group.color +
        ';' +
        '--hover:' +
        getHoverColor(group.color) +
        ';'
      "
      @click="switchGroupContent(group.documentId)"
    >
      <span class="group-name truncate" :style="{ '--color': group.color }">{{
        group.label
      }}</span>
      <span class="content-length" :style="'background:' + group.color + ';'">{{
        group.vessels.length
      }}</span>
      <div class="group-bar-background"></div>
    </div>
  </div>
</template>

<script>
/**
 * 選択船のグループバーのコンポーネント
 * 親から表示するグループオブジェクトを渡す。
 * @parent O.SelectedVessel
 * @props group: Object fireStoreに登録しているアカウントのお気に入りグループオブジェクト
 * @props switchGroupContent: Function クリックイベントで船情報の表示・非表示切替を行う。
 * @props isTargetGroupContentOpened: Functioin 船情報の表示中・非表示中を判定しスタイルの変更を行う。
 */
import { GROUP_COLOR_PALETTE } from "@/config/const.js";

export default {
  name: "M.GroupBar",
  props: {
    group: {
      type: Object,
    },
    switchGroupContent: {
      type: Function,
    },
    isTargetGroupContentOpened: {
      type: Function,
    },
  },
  methods: {
    getHoverColor(color) {
      const index = GROUP_COLOR_PALETTE.findIndex((element) => {
        return element.normal == color;
      });
      if (index != -1) {
        return GROUP_COLOR_PALETTE[index].deep;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.group-bar {
  width: 360px;
  height: 62px;
  position: relative;
  color: $aisea-pure-white;
  display: flex;
  background: $aisea-blue-gray;
  border-radius: 8px;
  border-left: solid 9px var(--color);
  box-sizing: border-box;
  padding: 8px 22px;
  margin: 0 auto;
  font-size: 17px;
  cursor: pointer;
  .group-name {
    width: 85%;
    color: white;
    line-height: 46px;
    pointer-events: none;
    transition: 0.3s;
    z-index: 1;
  }
  &:hover,
  &.selected {
    .group-name {
      color: var(--color);
    }
  }
  .content-length {
    pointer-events: none;
    line-height: 30px;
    width: 30px;
    height: 30px;
    margin: auto 10px auto auto;
    font-size: 14px;
    border-radius: 50%;
    text-align: center;
    display: inline-block;
    z-index: 1;
  }
  .group-bar-background {
    width: 100%;
    height: 100%;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    position: absolute;
    right: 0;
    top: 0;
    background: var(--hover);
    opacity: 0;
    transition: 0.3s;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
